import { useState, useEffect } from 'react';
import QuoteModal from '@/components/feature/QuoteModal';
import { useQuoteModal } from '@/hooks/useQuoteModal';

export default function FloatingQuoteButton() {
  const [visible, setVisible] = useState(false);
  const { isOpen, open, close } = useQuoteModal();

  useEffect(() => {
    const handleScroll = () => {
      // Show FAB after scrolling past 60% of viewport height
      const threshold = window.innerHeight * 0.6;
      setVisible(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <QuoteModal isOpen={isOpen} onClose={close} />

      {/* Floating Quote Button - Mobile Only */}
      <button
        type="button"
        onClick={open}
        className={`fixed bottom-5 right-5 z-50 md:hidden flex items-center gap-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm shadow-xl shadow-primary-500/30 transition-all duration-500 cursor-pointer whitespace-nowrap ${
          visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
        }`}
        aria-label="Solicitar cotización"
      >
        <i className="ri-file-list-3-line text-base" />
        Cotizar
      </button>

      {/* Floating Quote Button - Desktop (more subtle) */}
      <button
        type="button"
        onClick={open}
        className={`fixed bottom-6 right-6 z-50 hidden md:flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm shadow-xl shadow-primary-500/30 transition-all duration-500 cursor-pointer whitespace-nowrap ${
          visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
        }`}
        aria-label="Solicitar cotización"
      >
        <i className="ri-file-list-3-line text-base" />
        Solicitar Cotización
      </button>
    </>
  );
}